import { getMessagesBlockedRedirect, normalizeUserRole } from './messagesAccess'

/** Deal checklist is available to admins, advisors/brokers, and sellers. */
export function canAccessDealChecklist(role) {
  const normalized = normalizeUserRole(role)
  return normalized === 'admin' || normalized === 'advisor' || normalized === 'broker' || normalized === 'seller'
}

export function isDealChecklistHiddenForRole(role) {
  return !canAccessDealChecklist(role)
}

export function getDealChecklistBlockedRedirect(role) {
  return getMessagesBlockedRedirect(role)
}
